package com.example.socialmediaapp.network

import kotlinx.serialization.Serializable

@Serializable
data class RawAdminStats(
    val users: Int,
    val sessions: Int,
    val posts: Int,
    val uptime: Double,
    val ghostCounter: String? = null
)

@Serializable
data class RawAdminLog(
    val timestamp: String,
    val method: String? = null,
    val url: String? = null,
    val statusCode: Int? = null,
    val ghostId: String? = null,
    val alert: String? = null,
    val reason: String? = null
)

class AdminRepository(private val apiClient: ApiClient) {

    suspend fun getStats(): Result<RawAdminStats> = runCatching {
        apiClient.get("/api/admin/stats")
    }

    suspend fun getRecentLogs(): Result<List<RawAdminLog>> = runCatching {
        apiClient.get("/api/admin/logs/recent")
    }
}
